<template>
  <div id="layout_home">
    <el-container>
      <el-header style="position:fixed;width:100%;z-index:999;">
        <el-menu  style="padding:0 100px;"          
          class="el-menu-demo"
          mode="horizontal"
          :default-active="this.$store.state.currentIndex"
          @select="handleSelect"
          background-color="#ffffff"
          text-color="#324A51"
          :router="true"
          active-text-color="#0bc8f4">
          <div style="width:100px;float:left;margin-right:30px;">
            <!-- <img src="../assets/images/logo.png" style="width:100%;height:60px;line-height:60px;" alt=""> -->
            <el-image :src="logo" style="cursor:pointer;" fit="cover" />
            <!-- <el-image :src="logo"></el-image> -->
          </div>
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/search">薪酬查询</el-menu-item>
          <!-- <el-menu-item index="/person">个人薪酬</el-menu-item> -->
          <el-menu-item index="/graduate">毕业生薪酬</el-menu-item>
            <!-- <template slot="title"><a style="text-decoration:none;color:rgb(50, 74, 81)" target="_blank" href="http://www.wisechoices.cn">测评咨询<sup style="font-size:12px;color:red;padding-left:4px;">新</sup></a></template> -->
          <!-- <el-menu-item index="/check">在线测评<sup style="font-size:12px;color:red;padding-left:4px;">新</sup></el-menu-item> -->
          <el-submenu index="/check">
            <template slot="title">测评培训</template>
            <el-menu-item index="/check">DISC在线测评</el-menu-item>
            <el-menu-item index="/mbti">MBTI在线测评</el-menu-item>
            <el-menu-item index="/personality">九型人格在线测试</el-menu-item>
            <el-menu-item index="/manyidu">满意度敬业度</el-menu-item>
            <el-menu-item index="/peixun">培训课程</el-menu-item>
            <el-menu-item v-show="false" index="/kechengxiangqing">培训</el-menu-item>
          </el-submenu>
          <el-menu-item index="/toolbox">工具箱</el-menu-item>
          <el-menu-item index="/recommend">HR服务推荐<sup style="font-size:12px;color:red;padding-left:4px;">火</sup></el-menu-item>          
          <el-menu-item index="/about">关于我们</el-menu-item>
          <!-- <el-menu-item index="/analyze">对比分析</el-menu-item>
          <el-menu-item index="/salary-system">薪酬体系方案</el-menu-item> -->
          <div style="float:right;line-height:60px;">
            <div v-if="!isLogin">
              <el-button type="primary" size="small" @click="gotoLogin">登录</el-button>
              <el-button type="info" size="small" plain @click="gotoRegiste">注册</el-button>
            </div>
            <div v-if="isLogin">
              <el-button type="warning" size="small" plain @click="gotoMemberCenter">个人中心</el-button>
              <el-button type="danger" size="small" plain ghost @click="logout">安全退出</el-button>
            </div>
          </div>
        </el-menu>
      </el-header>
      <!-- 主页模板 -->
      <div style="min-height:600px;">
        <keep-alive>
          <transition :name="transitionName">   
            <router-view></router-view>
          </transition>
        </keep-alive>    
      </div>     
      <!-- 主页模板 -->
      
      <div class="bottom">
        <el-row  type="flex" justify="space-around">
          <el-col :span="20" :offset="4">
            <el-row :gutter="60">
              <el-col :span="7">
                <div class="title">联系我们
                  
                </div>
                <div class="subtitle">地址：北京市通州区华远好天地A座5层</div>
                <div class="subtitle">电话：400-809-8577</div>
                <div class="subtitle">邮箱：tz@taizhicn.com</div>
              </el-col>
              <el-col :span="5">
                <div class="title">友情链接
                  
                </div>
                <el-row>
                  <el-col :span="12"  class="subtitle">
                    智联招聘
                  </el-col>
                  <el-col :span="12"  class="subtitle">
                    2号人事部
                  </el-col>
                  <el-col :span="12"  class="subtitle">
                    中华英才
                  </el-col>
                  <el-col :span="12"  class="subtitle">
                    易才集团
                  </el-col>
                  <el-col :span="12"  class="subtitle">
                    睿和集团
                  </el-col>
                  <el-col :span="12"  class="subtitle">
                    知远咨询
                  </el-col>
                  <el-col :span="12"  class="subtitle">
                    看准网
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="4">
                <div class="title">微信公众号</div>
                <img src="../assets/icons/qrcode.jpg" style="height:100px;" alt="">
              </el-col>
              <el-col :span="6">
                <div class="title">网站问题反馈</div>
                <img src="../assets/feedback.png" style="height:100px;" alt="">
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <el-footer class="footer">
        <div>Copyright © 2019 北京太智联合企业管理顾问有限公司 版权所有 | <span><a class="beian" target="_blank" href="http://beian.miit.gov.cn">京ICP备12035558号-2</a></span></div>
      </el-footer>          
    </el-container>
  </div>
</template>
<script>
import LOGO from "../assets/images/logo.png";
import {menus} from '../helper';
export default {
  name: "layout_home",
  data() {
    return {
      logo: LOGO,
      textarea: "",
      isLogin:false,
      transitionName:''
    };
  },
  watch: {//使用watch 监听$router的变化
    $route(to, from) {
      //如果to索引大于from索引,判断为前进状态,反之则为后退状态
      if(to.meta.index > from.meta.index){
	    //设置动画名称
        this.transitionName = 'slide-left';
      }else{
        this.transitionName = 'slide-right';
      }
    }
  },
  mounted(){
    let currentIndex = this.$route.path;
    this.$store.dispatch('setCurrentIndexFun',currentIndex)
    if(sessionStorage.getItem('token') != null){
      this.isLogin = true;
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      
      ////console.log(key, keyPath);     
      // this.$store.dispatch('setCurrentIndexFun',key) 
    },
    gotoHome(){
      this.currentIndex = '';
      this.$router.push('/');
    },
    gotoLogin(){
      this.$router.push('login');
    },
    gotoRegiste(){
      this.$router.push('registe');
    },
    gotoMemberCenter(){
      this.$router.push('/member-center');
    },
    logout(){
      sessionStorage.clear();
      this.$router.go(0)
    },
  }
};
</script>
<style scoped>
#home {
  background-color: #f4f4f4;
}
.main-container {
  margin: 0 100px;
}
.footer {
  background-color: #0bc8f4;
  line-height: 60px;
  text-align: center;
  color: #ffffff;
  font-size: 14px;
}
.bottom{
  padding: 60px;
  background-color: #0bc8f4;
  color:#ffffff;
}
.title{
  font-size: 16px;
  padding:0 0 20px 0;
  position: relative;
}
.subtitle{
  font-size: 14px;
  padding-bottom: 10px;
}
.beian{
  text-decoration: none;
  color: #ffffff;
}

</style>

